//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
	props: {
		show: {		//遮罩层与内容的展示
			type: Boolean,
			default: false
		},
		showBtn:{	//是否展示默认按钮
			type:Boolean,
			default:true
		}
	},
	watch: {
		show(val) {
			if(!val){
					this.hidden = false
			} else {
				this.hidden = true
			}
		}
	},
	data() {
		return {
			hidden:false
		}
	},
	methods: {
		cancel() {
			this.$emit('cancel')
		},
		confirm() {
			this.$emit('confirm')
		}
	},
}
